import {useRouter} from "next/router"
import {useEffect} from "react"

export const useScrollToHash = () => {
	const router = useRouter()

	useEffect(() => {
		if (typeof window === "undefined") return

		const hash =
			window.location.hash || sessionStorage.getItem("scrollTarget")

		if (hash) {
			setTimeout(() => {
				const el = document.getElementById(hash.replace("#", ""))
				if (el) {
					const yOffset = -120
					const y =
						el.getBoundingClientRect().top +
						window.pageYOffset +
						yOffset
					window.scrollTo({top: y, behavior: "smooth"})
				}
				sessionStorage.removeItem("scrollTarget")
			}, 100)
		}
	}, [router.asPath])
}
